module.exports = __webpack_public_path__ + "media/pt_pt_s3_Leonor.f1db60dc.oga";